export default {
  AVATARS: "AVATARS",
  CLOUD_ACCOUNT: "CLOUD_ACCOUNT",
  COMMANDS: "COMMANDS",
  LULLABIES: "LULLABIES",
  CLOUD_SETTINGS: "CLOUD_SETTINGS",
  DEVICES: "DEVICES"
};

export const ProtoBuff = {
  ALL: {
    value: "ALL",
    serverValue: "all"
  },
  AVATARS: {
    value: "AVATARS",
    serverValue: "avatars"
  },
  CLOUD_ACCOUNT: {
    value: "CLOUD_ACCOUNT",
    serverValue: "cloudAccount"
  },
  COMMANDS: {
    value: "COMMANDS",
    serverValue: "commands"
  },
  LULLABIES: {
    value: "LULLABIES",
    serverValue: "lullabies"
  },
  CLOUD_SETTINGS: {
    value: "CLOUD_SETTINGS",
    serverValue: "cloudSettings"
  },
  DEVICES: {
    value: "DEVICES",
    serverValue: "devices"
  }
};

export const Server = {
  all: {
    value: "all",
    protoBuffValue: "ALL"
  },
  avatars: {
    vlaue: "avatars",
    protoBuffValue: "AVATARS"
  },
  cloudAccount: {
    vlaue: "cloudAccount",
    protoBuffValue: "CLOUD_ACCOUNT"
  },
  commands: {
    vlaue: "commands",
    protoBuffValue: "COMMANDS"
  },
  lullabies: {
    value: "lullabies",
    protoBuffValue: "LULLABIES"
  },
  cloudSettings: {
    value: "cloudSettings",
    protoBuffValue: "CLOUD_SETTINGS"
  },
  devices: {
    value: "devices",
    protoBuffValue: "DEVICES"
  }
};
